export const RESTAURANTS_IMG_TITLE = 'Let your recipient pick their favorite restaurant!';
export const RESTAURANTS_IMG_URL = '/cyo_restaurant.png';
export const RESTAURANTS_DESCRIPTION = '3+ million local restaurants';

export const giftCardDefaultTypes = ['choose_your_own_restaurant', 'choose_your_own_spas_and_salons'];

export const giftCardServiceProviderTypes = [
  'choose_your_own_serviceprovider_home',
  'choose_your_own_serviceprovider_personal',
  'choose_your_own_serviceprovider_auto',
];

export const giftCardFlipGiveTypes = [
  'choose_your_own_restaurant_bars',
  'choose_your_own_restaurant_coffee',
  'choose_your_own_restaurants_spas_salons',
];

export const configurationPageDescriptions: any = {
  choose_your_own_restaurant: '3+ million local restaurants',
  choose_your_own_spas_and_salons: '3 million local spas and salons',
  choose_your_own_serviceprovider_home: '7 million local service providers',
  choose_your_own_serviceprovider_personal: '7 million local service providers',
  choose_your_own_serviceprovider_auto: '7 million local service providers',
  choose_your_own_restaurant_bars: '50,000+ local bars',
  choose_your_own_restaurant_coffee: '50,000+ local coffee shops',
  choose_your_own_restaurants_spas_salons: '5 million local restaurants, spas, and salons',
};

export const configurationPageTitles: any = {
  choose_your_own_restaurant: 'Let your recipient pick their favorite restaurant!',
  choose_your_own_spas_and_salons: 'Let your recipient pick their favorite spa or salon!',
  choose_your_own_serviceprovider_home: 'Let your recipient pick a local service provider!',
  choose_your_own_serviceprovider_personal: 'Let your recipient pick a local service provider!',
  choose_your_own_serviceprovider_auto: 'Let your recipient pick a local service provider!',
  choose_your_own_restaurant_bars: 'Let your recipient pick their favorite bar!',
  choose_your_own_restaurant_coffee: 'Let your recipient pick their favorite coffee shop!',
  choose_your_own_restaurants_spas_salons: 'Let your recipient pick their favorite restaurant, spa and salon!',

  //MCC Category
  restaurant: 'Let your recipient pick their favorite restaurant!',
  spa: 'Let your recipient pick their favorite spa or salon!',
  serviceprovider: 'Let your recipient pick a local service provider!',
};

export const configurationPageServiceCardProgram: any = {
  coffee: 'choose_your_own_restaurant_coffee',
  bars: 'choose_your_own_restaurant_bars',
  favorite: 'choose_your_own_restaurants_spas_salons',
};

export const CartItemImages: any = {
  choose_your_own_restaurant: '/cyo_restaurant.png',
  choose_your_own_spas: '/cyo_spas_and_salons.png',
  choose_your_own_salons: '/cyo_spas_and_salons.png',
  choose_your_own_spas_and_salons: '/cyo_spas_and_salons.png',
  choose_your_own_serviceprovider_home: '/cyo_serviceprovider_home.png',
  choose_your_own_serviceprovider_personal: '/cyo_serviceprovider_personal.png',
  choose_your_own_serviceprovider_auto: '/cyo_serviceprovider_auto.png',
  choose_your_own_restaurant_bars: '/cyo_restaurant_bars.png',
  choose_your_own_restaurant_coffee: '/cyo_restaurant_coffee.png',
  choose_your_own_restaurants_spas_salons: '/cyo_restaurants_spas_salons.png',
};
